<template>
  <div id="app" class="w-full min-h-screen overflow-hidden bg-gray-50">
    <div class="w-full min-h-screen flex flex-col items-center justify-center px-4">
      <div class="mb-6">Thank You</div>
      <p class="mb-4 text-xs text-center max-w-sm">{{ finePrint }}</p>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Thank You',
  },
  props: [
    'type',
  ],
  computed: {
    finePrint() {
      if (this.type === 'pickup') {
        return 'Pre-paid orders that are not picked up within 48 hours will be returned. A store credit will be issued to the customer and any dispensations will be reversed. Unpaid orders that are not picked up by 8pm will be cancelled.';
      }

      if (this.type === 'delivery') {
        return 'If a delivery order is not deliverable the order will be returned and any dispensations reversed. If the order was prepaid a store credit will be issued to the customer.';
      }

      return '';
    },
  },
};
</script>
